import React from 'react';

import { createIcon } from '../createIcon';

function SvgMenu(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path d="M2 2h12v12H2z" />
        <path
          d="M2.839 7H13.16c.463 0 .838.448.838 1 0 .51-.32.93-.733.992L13.161 9H2.839C2.375 9 2 8.552 2 8c0-.51.32-.93.733-.992L2.84 7H13.16 2.839zM2.839 3H13.16c.463 0 .838.448.838 1 0 .51-.32.93-.733.992L13.161 5H2.839C2.375 5 2 4.552 2 4c0-.51.32-.93.733-.992L2.84 3H13.16 2.839zM2.839 11H13.16c.463 0 .838.448.838 1 0 .51-.32.93-.733.992l-.105.008H2.839C2.375 13 2 12.552 2 12c0-.51.32-.93.733-.992L2.84 11H13.16 2.839z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export const MenuFilledIcon = createIcon(SvgMenu, 'MenuFilledIcon');
